<template>

</template>

<script>
export default {
name: "BaseCard"
}
</script>

<style scoped>

</style>